module.exports = __webpack_public_path__ + "img/V-63-ER-1200-BE.8e36ac70.png";